import React from 'react';
import Form from '../../../../molecules/Form';
import IForm from '../../../../../types/IForm';
import { RefreshCallback } from '../../../../../_lib/FetchContainer';
import { ConnectActionFormTemplate } from './ConnectActionFormTemplate';

type ConnectActionFormType = {
  form: IForm;
  actionType: 'connectBlocks';
  refreshBlock: RefreshCallback;
};

export function ConnectActionForm({ form, actionType, refreshBlock }: ConnectActionFormType) {
  return (
    <Form
      id="connect-action-form"
      model={form}
      onSuccess={() => {
        if (refreshBlock) {
          setTimeout(refreshBlock, 2000);
        }
      }}
    >
      <ConnectActionFormTemplate actionType={actionType} />
    </Form>
  );
}
